var l = Object.defineProperty;
var f = (e, o, r) => o in e ? l(e, o, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[o] = r;
var h = (e, o, r) => f(e, typeof o != "symbol" ? o + "" : o, r);
import { COOKIE_SERVICE as u, LOGGER as k } from "@packages/common";
import { CONFIG as C } from "@packages/config";
import { Injectable as v, Inject as s } from "@webmotors/ioc";
import { AUTH_SERVICE as m } from "./main8.js";
var p = Object.getOwnPropertyDescriptor, _ = (e, o, r, t) => {
  for (var i = t > 1 ? void 0 : t ? p(o, r) : o, g = e.length - 1, a; g >= 0; g--)
    (a = e[g]) && (i = a(i) || i);
  return i;
}, c = (e, o) => (r, t) => o(r, t, e);
let n = class {
  /**
   * Constructor method
   *
   * @param cookie - The service used to remove items from cookie
   * @param loggerFactory - The logger service
   */
  constructor(e, o, r) {
    h(this, "logger");
    this.cookie = e, this.loggerFactory = o, this.config = r, this.logger = this.loggerFactory.create(m);
  }
  /**
   * Logs the current logged user out
   *
   * @returns A promise that resolves to a boolean indicating success
   */
  async logout() {
    return this.logger.info("[Logout] Logging user out..."), this.cookie.removeCookie(this.config.authCookieName), this.cookie.removeCookie(this.config.accessTokenCookieName), this.cookie.removeCookie(this.config.refreshTokenCookieName), this.logger.info("[Logout] User logged out."), !0;
  }
};
n = _([
  v(m),
  c(0, s(u)),
  c(1, s(k)),
  c(2, s(C))
], n);
export {
  n as AuthService
};
